import * as ACTION_TYPES from './Types'

const initialState = {
    message: "",
    error: null,
    farmerMarketList: { recordsTotal: 0 },
    farmerMarket: {},
    farmerEvent: {},
    allState: {},
    allCounty: {},
    page: 1,
    limit: 10,
    event: {}
}

export const MarketReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.FETCH_FARMERMARKET_SUCCESS:
            return {
                ...state,
                farmerMarketList: action.payload.data,
                message: action.payload.message,
                error: null
            }
        case ACTION_TYPES.GET_EVENT_SUCCESS:
            return {
                ...state,
                event: action.payload.data,
                message: action.payload.message,
                error: null
            }
        case ACTION_TYPES.MARKET_PAGE_CHANGE:
            return {
                ...state,
                page: action.payload
            }
        case ACTION_TYPES.MARKET_LIMIT_CHANGE:
            return {
                ...state,
                limit: action.payload
            }
        case ACTION_TYPES.ADD_MARKET_SUCCESS:
        case ACTION_TYPES.FETCH_MARKET_INFO_SUCCESS:
            return {
                ...state,
                farmerMarket: action.payload.data,
                message: action.payload.message,
                isEdited: false,
                error: null
            }
        case ACTION_TYPES.ADD_EVENT_SUCCESS:
            return {
                ...state,
                farmerEvent: action.payload.data,
                message: action.payload.message,
                isEdited: false,
                error: null
            }
        case ACTION_TYPES.GET_EVENT_ERROR:
            return {
                ...state,
                message: action.payload.data.message,
                error: action.payload.data.message,
                isEdited: false
            }
        case ACTION_TYPES.EDIT_EVENT_SUCCESS:
            return {
                ...state,
                farmerEvent: action.payload.data,
                message: action.payload.message,
                isEdited: false,
                error: null
            }
        case ACTION_TYPES.EDIT_MARKET_SUCCESS:
            return {
                ...state,
                farmerMarket: action.payload.data,
                message: action.payload.message,
                isEdited: true,
                error: null
            }
        case ACTION_TYPES.FETCH_FARMERMARKET_ERROR:
        case ACTION_TYPES.ADD_MARKET_ERROR:
            return {
                ...state,
                message: action.payload.data.message,
                error: action.payload.data.message,
                isEdited: false
            }
        case ACTION_TYPES.FETCH_MARKET_INFO_ERROR:
            return {
                ...state,
                farmerMarket: null,
                message: action.payload.data.message,
                error: action.payload.data.message
            }
        case ACTION_TYPES.EDIT_MARKET_ERROR:
            return {
                ...state,
                message: action.payload.data.message,
                error: action.payload.data.message,
                isEdited: false
            }
        case ACTION_TYPES.EDIT_EVENT_ERROR:
            return {
                ...state,
                message: action.payload.data.message,
                error: action.payload.data.message,
                isEdited: false
            }
        case ACTION_TYPES.GET_STATELIST_SUCCESS:
            return {
                ...state,
                allState: action.payload.data,
                message: action.payload.message,
            }
        case ACTION_TYPES.GET_STATELIST_ERROR:
            return {
                ...state,
                message: action.payload.data.message,
                error: action.payload.data.message,
            }
        case ACTION_TYPES.GET_COUNTYLIST_SUCCESS:
            return {
                ...state,
                allCounty: action.payload.data,
                message: action.payload.message,
            }
        case ACTION_TYPES.GET_COUNTYLIST_ERROR:
            return {
                ...state,
                message: action.payload.data.message,
                error: action.payload.data.message,
            }
        default:
            return state
    }
}

